import { trackClickEvent } from '@/components/account/PlayKitSchedule/utils';
import { GenInternalLink } from '@/components/generics';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';
import { TypeAddOnProductComponent } from '@/lib/api/productCatalog/types';
import { getPlayKitProductDescription } from '@/utils/productHelpers';
import { CTA_NAMES } from '@/utils/rudderstack';
import Image from 'next/image';

export interface AddOnDetailsProps {
  title: string;
  linkCopy: string;
  linkHref: string;
  showLink: boolean;
  addOnProducts: TypeAddOnProductComponent[];
}

function AddOnDetails({
  title,
  linkCopy,
  linkHref,
  showLink,
  addOnProducts,
}: AddOnDetailsProps) {
  return (
    <div className="pb-5">
      <div className="flex md:gap-4 pb-4 flex-row gap-2 items-center">
        <Heading
          classes="w-max"
          tag={HeadingTag.H3}
          size={HeadingSize.H3}
          text={title}
        />
        {showLink && linkCopy && linkHref && (
          <GenInternalLink
            classes="text-base md:text-xl "
            href={linkHref}
            cta={linkCopy}
            onClick={() => {
              trackClickEvent(CTA_NAMES.REMOVE_BOOK_BUNDLE);
            }}
          />
        )}
      </div>
      <div className="flex flex-col gap-4 md:flex-row">
        {addOnProducts &&
          addOnProducts.map((item, index) => (
            <div key={index} className="flex flex-row w-full gap-4">
              <Image
                className="md:min-w-[104px] md:min-h-[104px] min-w-[88px] min-h-[88px] object-contain"
                src={item.media[0].uri}
                alt={item.copy_text.title}
                height={104}
                width={104}
              />
              <div className="flex flex-col">
                <p className="text-sm font-bold w-full">
                  {item.copy_text.title}
                </p>
                <p className="text-sm">
                  {getPlayKitProductDescription(
                    item.copy_text.description_html,
                  )}
                </p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default AddOnDetails;
